<template>
  <div>
    <a-spin :spinning="loading">
      <div class="row mt-2">
        <div class="col-12 col-md-2">
          <p>
            <span style="font-weight:bold">Report card formats</span>
            <template>
              <a-radio-group
                name="radioGroup"
                :default-value="1"
                @change="getFormat"
              >
                <a-radio :value="1">
                  PRE-KG
                </a-radio>
                <a-radio :value="0">
                  I-X
                </a-radio>
              </a-radio-group>
            </template>
          </p>
          <!-- section -->
            <div>
              <a-form-item label="Select Section">
                <a-select
                  placeholder="Select a section"
                  v-decorator="[
                    'section',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Select section!'
                        }
                      ],
                      initialValue: undefined
                    }
                  ]"
                  @change="getSectionStudents"
                  style="width:170px"
                >
                  <a-select-option
                    v-for="sec in classSections"
                    :key="sec.id"
                    :value="sec.id"
                    >{{ sec.name }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </div>
          <!-- Student List -->
          <template v-if="data.length">
            <p class="mb-0 font-weight-bold mb-1">Students</p>
            <a-divider />
            <!-- {{data}} -->
            <p
              :class="['mb-0']"
              v-for="student in data"
              :key="student.enrollment[0].id"
            >
              <a
                :class="[
                  'mb-0',
                  `${
                    selectedStudentId === student.enrollment[0].id
                      ? 'text-primary'
                      : ''
                  }`
                ]"
                href="javascript:0;"
                @click="
                  handlingStudentSelect(student.id, student.enrollment[0].id)
                "
              >
                {{ student.first_name }} {{ student.last_name }} ({{
                  student.enrollment[0].roll_no
                }})
              </a>
            </p>
          </template>
          <template v-if="!data.length">
            <p class="mb-0 font-weight-bold mb-1">Students</p>
            <a-divider />
            <NoData text="No students found" />
          </template>
        </div>
        <div class="col-md-10">
          <!-- <a-spin :spinning="loadingReport"> -->
          <reports-view
            :data="data"
            :sessionId="sessionId"
            :classId="classId"
            :sectionId="selectedSection"
            :selectedStudent_Ids="selectedStudent_Ids"
            :getSelectedStudentExamDetails="getSelectedStudentExamDetails"
            :classSubjects="classSubjects"
            :reportFormat="format"
          />
          <!-- </a-spin> -->
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
// import { debounce } from 'lodash'
import NoData from '@/components/layout/NoData/index'

import ReportsView from '@/components/bosemexam/final/Report/partials/FinalReport'

export default {
  name: 'DisplayFinalClassReport',
  components: {
    NoData,
    ReportsView,
  },
  mounted: function() {
    this.getClassSections()
    // this.getClassSectionStudents(false)
  },
  // created() {
  //   this.searchStudents = debounce(this.getClassSectionStudents, 500)
  // },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      classSections: [],
      selectedSection: 0,
      selectedStudentId: 1,
      selectedStudent: {},
      studentData: null,
      search: null,
      data: [],
      current: 1,
      pageSize: 100,
      meta: {},
      selectedStudents: [],
      spa: ' ',
      getSelectedStudentExamDetails: [],
      checked: false,
      selectedStudent_Ids: [],
      studentsPushExamDetails: [],
      selectedStdId: undefined,
      classSubjects: [],
      format: 1,
      loadingReport: false,
    }
  },
  computed: {
    classId: function() {
      return this.$route.params.classId
    },
    className: function() {
      return this.$route.params.className
    },
    sessionId: function() {
      return this.$route.params.sessionId
    },
  },
  watch: {
    selectedSection: function(value) {
      return value
    },
    checked: function(value) {
      return value
    },
    format: function(value) {
      return value
    },
    classSubjects: function(value) {
      return value
    },
    selectedStdId: function(value) {
      return value
    },
    data: function(value) {
      if (value.length) {
        this.selectedStudentId = value[0].enrollment[0].id
        this.selectedStudent = value[0]
      } else {
        this.selectedStudentId = null
      }
    },
  },
  methods: {
    getFormat(e) {
      this.format = e.target.value
    },
    // checkonChange(event, studentId, enrollid) {
    handlingStudentSelect(studentId, enrollid) {
      this.loadingReport = true
      this.getClassSubjects()
      this.studentsPushExamDetails = []
      this.selectedStudent_Ids = studentId
      this.$http
        .get(`/api/reports/student/bosem_final_result/${enrollid}`)
        .then(({ data }) => {
          this.loadingReport = false
          this.getSelectedStudentExamDetails = data.data
        })
    },
    getClassSubjects() {
      this.loading = true
      this.$http
        .get('/api/subject/class/' + this.classId, {
          params: {
            session_id: this.sessionId,
          },
        })
        .then(({ data }) => {
          this.classSubjects = data.data.normal_subjects
          this.loading = false
        })
    },
    getClassSections() {
      this.loading = true
      this.$http
        .get('/api/section/class/' + this.classId, {
          params: {
            session_id: this.session,
          },
        })
        .then(({ data }) => {
          this.loading = false
          if (data.data.length) {
            this.classSections = data.data
          }
        })
    },
    handleSectionChange(sectionId) {
      this.getClassSectionStudents()
    },
    handleStudentSelect(studentId, student, id) {
      this.selectedStudentId = studentId
      this.selectedStudent = student
      this.selectedStdId = id
    },
    searchStudents: function(e) {
      this.search = e.target.value
      this.getClassSectionStudents(true)
    },
    getSectionStudents(e) {
      this.selectedSection = e
      this.getClassSectionStudents()
    },
    getClassSectionStudents(isSearch) {
      this.data = []
      this.loading = true
      let page = this.current
      if (isSearch) {
        page = 1
        this.current = 1
      }
      this.$http
        .get('/api/student', {
          params: {
            limit: this.pageSize,
            page: page,
            search: this.search,
            class_id: this.classId,
            section_id:
              this.selectedSection === 0 ? undefined : this.selectedSection,
            session_id: this.sessionId,
            order_by: 'roll_no',
          },
        })
        .then(({ data }) => {
          this.loading = false
          this.data = data.data.sort((a, b) => parseInt(a.enrollment[0].roll_no) - parseInt(b.enrollment[0].roll_no))
          this.meta = data.meta
          // console.log('student', this.data)
        })
    },
  },
}
</script>
